import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionToggleCardLockedCodes = {
  AutomationV2ExecutionActionToggleCardLockedCastToBooleanFailed: {
    code: 'automation-v2-execution-action/toggle-card-locked-cast-to-boolean-failed',
    explanation: `Valor inválido para o estado de bloqueio (esperado booleano).

**Causas comuns:**
- Passar string "sim"/"não" em vez de true/false

**Como resolver:**
Use valores booleanos (true/false) para configurar o bloqueio.`,
    localizations: {},
    message: 'Houve um erro ao tentar converter o estado de bloqueio do card.',
    supportingDocs: [
      {
        name: 'Ação de Bloquear/Desbloquear Card',
        path: '/wiki/docs/automations/actions/toggle-card-lock',
      },
    ],
  },
  AutomationV2ExecutionActionToggleCardLockedFailedToToggleCardLocked: {
    code: 'automation-v2-execution-action/toggle-card-locked-failed-to-toggle-card-locked',
    explanation: `Falha ao bloquear/desbloquear card.

**Causas comuns:**
- Erro de permissão
- Card em estado inconsistente

**Como diagnosticar:**
Verifique se o usuário da automação tem permissão para bloquear cards.`,
    localizations: {},
    message: 'Houve um erro ao tentar alternar o estado de bloqueio do card.',
    supportingDocs: [
      {
        name: 'Ação de Bloquear/Desbloquear Card',
        path: '/wiki/docs/automations/actions/toggle-card-lock',
      },
    ],
  },
  AutomationV2ExecutionActionToggleCardLockedMissingCardId: {
    code: 'automation-v2-execution-action/toggle-card-locked-missing-card-id',
    explanation: `ID do card é obrigatório no contexto da ação. O id do card é automaticamente passado pelo gatilho ou por ações anteriores.

**Causas comuns:**
- Variável cardId não resolvida
- Caso o valor do cardId seja mapeado manualmente, pode ter sido digitado incorretamente.
- Caso o valor do cardId não tenha sido mapeado, o \`context.card.id\` não está disponível.

**Como resolver:**
Corrija o mapeamento do ID do card.`,
    localizations: {},
    message: 'ID do card não foi fornecido.',
    supportingDocs: [
      {
        name: 'Ação de Bloquear/Desbloquear Card',
        path: '/wiki/docs/automations/actions/toggle-card-lock',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
